import { createContext, useContext, useState } from "react";

const globalLoaderContext = createContext();
const useGlobalLoader = () => useContext(globalLoaderContext)

const GlobalLoaderProvider = ({ children }) => {
    const [loading, setLoading] = useState(false)
    const start = () => {
        setLoading(true)
    }
    const end = () => {
        setLoading(false)
    }
    return (
        <globalLoaderContext.Provider value={{ start, end, loading }}>
            {children}
        </globalLoaderContext.Provider>
    )
}

export default useGlobalLoader
export { GlobalLoaderProvider }